import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const TabNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();



  const handleNavigation = (path: string) => {
    navigate(path);
  };

  // Déterminer quelle tab est active
  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/classement') return 'ranking';
    return '';
  };

  const activeTab = getActiveTab();

  return (
    <div className="fixed top-0 left-0 right-0 bg-white shadow-lg z-30 pt-safe">
      <div className="flex justify-center items-center h-16">
        <div className="flex w-full justify-around">
          {/* Tab Accueil */}
          <button 
            onClick={() => handleNavigation('/')}
            className={`flex flex-col items-center justify-center w-full h-full ${activeTab === 'home' ? 'text-primary' : 'text-gray-500'}`}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
            <span className="text-xs mt-1">Accueil</span>
          </button>

          {/* Tab Classement */}
          <button 
            onClick={() => handleNavigation('/classement')}
            className={`flex flex-col items-center justify-center w-full h-full ${activeTab === 'ranking' ? 'text-primary' : 'text-gray-500'}`}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
            </svg>
            <span className="text-xs mt-1">Classement</span>
          </button>


        </div>
      </div>
    </div>
  );
};
